'use client'
import { useContext, useRef } from 'react'
import { CurrentUserContext } from '../util/user-context'

export const userModalId = 'user-modal'
const UserModal = () => {
    const { user } = useContext(CurrentUserContext)
    const dialogRef = useRef<HTMLDialogElement>(null)
    return (
        <dialog id={userModalId} className="modal" ref={dialogRef}>
            <div className="modal-box">
                <form method="dialog">
                    {/* if there is a button in form, it will close the modal */}
                    <button className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">✕</button>
                </form>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-bold">Account Details</h3>
                    <h5 className="">
                        Hello {user?.givenName}
                        {user?.lastName ? ' ' + user?.lastName : ''}!
                    </h5>
                    <ul className="text-sm">
                        <li>Email: {user?.email}</li>
                        {user.subscriptionEnd && (
                            <>
                                <li>Expires: {new Date(user.subscriptionEnd).toLocaleString()}</li>
                            </>
                        )}
                        <li></li>
                    </ul>
                    <a href="https://billing.stripe.com/p/login/7sI6qd3xx6af14A000" className="underline">
                        Manage your subscription
                    </a>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}
export default UserModal
